<mat-card>
    <mat-card-content>
            <div class="resume-title" >Resumo do pedido</div>
            <mat-divider inset="" ></mat-divider>
            <div class="actual-plan-card">
                <div class="primary-text">Meu plano</div>
                <div class="display-utils-col display-utils-xs-start-start ">
                    <p class="secondary-text">{{this.renewalInfo.contract.product.name}}</p>
                    <b class="primary-text">{{this.renewalInfo.invoiceValue | currency: 'R$'}}</b>
                    <div class="show-date">
                        <p class="secondary-text">Vencimento</p>
                        <p class="secondary-text">{{this.renewalInfo.renewalDates.contractExpire}}</p>
                    </div>
                </div>
            </div>
            <div class="renewal-plan-card">
                <div class="primary-text">Renovação</div>
                <div class="display-utils-col display-utils-xs-start-start">
                    <p class="secondary-text">{{this.renewalInfo.contract.product.name}}</p>
                    <b class="primary-text">{{this.renewalInfo.finalValue | currency: 'R$'}}</b>
                    <div class="show-date">
                        <p class="secondary-text">Início do plano</p>
                        <p class="secondary-text">{{this.renewalInfo.renewalDates.renewalStartDate}}</p>
                    </div>
                    <div class="show-date">
                        <p class="secondary-text">Término do plano</p>
                        <p class="secondary-text">{{this.renewalInfo.renewalDates.renewalFinalDate}}</p>
                    </div>
                </div>
            </div>
            <mat-divider inset="" class="divider"></mat-divider>
            <div class="changePlan-button" (click)="something()">
                <div class="button-container">
                    <span class="link">Voltar</span>
                </div>
            </div>
    </mat-card-content>
</mat-card>

